import { useState } from 'react';

function GenerateError({ onButtonClick }) {
  return (
    <>
      <div id="button-div">
        <button className="button" onClick={onButtonClick}>Deploy ECCD</button>
      </div>
    </>
  )
}

function RemoveEccdInstallation({ onRemoveButtonClick, disabledStatus }) {
  return (
    <>
      <button className="delete-button" onClick={onRemoveButtonClick} disabled={disabledStatus}>Remove ECCD installation</button>
    </>
  )
}

function ErrorLog({ value }) {

  if (value.substr(value.length - 2) == "..") {
    return (
      <>
        <div id="error-div">{value}<span class="blink_me">.</span>
        </div>
      </>
    )
  }
  else {
    return (
      <>
        <div id="error-div">{value}
        </div>
      </>
    )
  }
}

export default function Page() {
  const errors = [
    'Warning  FailedMount  97s (x17 over 20m)  kubelet            MountVolume.SetUp failed for volume "tls" : secret "kube-rbac-proxy" not found',
    'Retry 0: kubelet server certificate does not exist for node 172.16.210.21: %!s(<nil>)',
    'tls: failed to find any PEM data in key input',
    "No.",
    "Waiting for pods to be ready..",
    'FailedScheduling  13m (x2 over 18m)  default-scheduler  0/1 nodes are available: 1 node(s) had untolerated taint {node.cloudprovider.kubernetes.io/uninitialized: true}. preemption: 0/1 nodes are available: 1 Preemption is not helpful for scheduling.',
    '{"caller":"k8s.go:362","configmap":"kube-system/metallb-config","error":"bgp-peer \"10.131.1.225\" my-address-pool \"sig_ethlab_ngc_ccsm_eir_epc_dia_tcp\" doesn\'t exist","event":"configChange","msg":"failed to parse configmap","ts":"2024-11-13T21:37:04.813433035Z"}'
  ]
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [disabled, setDisabled] = useState(true);

  function getRandomError() {
    return errors[6]
    return errors[Math.floor(Math.random() * errors.length)];
  }

  function onRemoveButtonClick() {
    setButtonClicked(false)
    setErrorMessage("");
  }

  function onButtonClick() {
    console.log("Clicked!")
    const error_message = getRandomError()
    setErrorMessage(error_message);
    console.log("Remove button is disabled!")
    setButtonClicked(true)
    setTimeout(() => {
      console.log("Remove button is not disabled anymore!")
      setDisabled(false)
    }, 8000);
  }

  return (
    <>
      <div id="content">
        {!buttonClicked && <GenerateError onButtonClick={onButtonClick} />}
        <ErrorLog value={errorMessage} />
      </div >
      {buttonClicked && <RemoveEccdInstallation disabledStatus={disabled} onRemoveButtonClick={onRemoveButtonClick} />}
    </>
  );
}